<template>
  <v-btn :disabled="disabled" :loading="loading" v-on:click="click" color="primary" outlined :data-testid="dataTestid"><slot/></v-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    dataTestid: {
      type: String,
      default: null
    }
  },
  methods: {
    click: function (event) {
      this.$emit('click', event);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/OutlineButton.vue